import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import type { ReactNode } from "react";

type HeroCtaLinkProps = Readonly<{ children: ReactNode; className?: string }>;
type HeroCtaViewProps = Readonly<{
  children: ReactNode;
  /** The split hero's bigger button: 52px tall, one type step up. */
  large?: boolean | undefined;
}> &
  (
    | Readonly<{ editing: true }>
    | Readonly<{
        editing: false;
        renderLink(props: HeroCtaLinkProps): ReactNode;
      }>
  );

export function HeroCtaView(props: HeroCtaViewProps) {
  const presentation = stylex.props(styles.pill, props.large && styles.large);

  if (props.editing) return <span {...presentation}>{props.children}</span>;

  return props.renderLink({ ...presentation, children: props.children });
}

const styles = stylex.create({
  large: {
    minHeight: 52,
    paddingInline: spacing.space32,
    fontSize: fontSizes.sectionTitle,
    boxSizing: "border-box",
  },
  pill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 44,
    paddingBlock: spacing.space12,
    paddingInline: spacing.space24,
    borderRadius: radii.pill,
    backgroundColor: { default: colors.action, ":hover": colors.actionHover },
    color: colors.foreground,
    fontFamily: fonts.sans,
    fontSize: fontSizes.body,
    fontWeight: 500,
    textDecoration: "none",
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
  },
});
